import Queries from '../queries';

const { GET_SHARE_MEDIA_ID } = Queries;

const Mutation = {
    setShareMediaId: (_root, { mediaId }, { client }) => {

        client.writeQuery({
            query: GET_SHARE_MEDIA_ID,
            data: {
                shareMediaId: mediaId,
            },
        });

        return mediaId;

    },
};

export const resolvers = {
    Mutation,
};
